import { Record } from 'immutable';

import { TraceListEntity } from '../components/trace-list/trace-list.entity';

export const TraceSliceKey = 'main';

export interface ITraceOriginalSliceState {
	loading: boolean;
	list: TraceListEntity;
	total: number;
}

export const defaults: ITraceOriginalSliceState = {
	loading: false,
	list: TraceListEntity.build([]),
	total: 0,
};

export class TraceOriginalSliceState extends Record<ITraceOriginalSliceState>(
	defaults
) {
	public static readonly key = TraceSliceKey;

	public setLoading(isLoading: boolean): TraceOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setTraceList(traceList: TraceListEntity): TraceOriginalSliceState {
		return this.set('list', traceList);
	}

	public setTotal(total: number): TraceOriginalSliceState {
		return this.set('total', total);
	}
}
